import React from "react";
import ReactModal from "../Modal/Modal";

const SIZE_MAP = {
  sm: 400,
  md: 600,
  lg: 900,
  xl: 1100,
};

const resolveSize = (size) => {
  if (size === undefined || size === null || size === "") {
    return 600;
  }
  if (typeof size === "number" && !Number.isNaN(size)) {
    return size;
  }
  const key = String(size).toLowerCase();
  if (SIZE_MAP[key]) {
    return SIZE_MAP[key];
  }
  const parsed = parseInt(String(size), 10);
  return Number.isNaN(parsed) ? 600 : parsed;
};

/**
 * Legacy modal API (show / onCloseModal). Renders ReactModal for consistent app-wide styling.
 */
const SiteModal = ({ title, show, size, children, onCloseModal }) => {
  const handleSetOpen = (open) => {
    if (!open && onCloseModal) {
      onCloseModal();
    }
  };

  return (
    <ReactModal
      open={Boolean(show)}
      setOpen={handleSetOpen}
      title={title}
      size={resolveSize(size)}
    >
      {children}
    </ReactModal>
  );
};

export default SiteModal;
